// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__s+u9O","col1":"Footer_col1__ytm6o","col2":"Footer_col2__NdEG6","col3":"Footer_col3__wrI5P","cols":"Footer_cols__eW4Sd"};